<div class="table-wrapper">
  <div class="table-container">
    <table class="crud-table">
      <thead>
        <tr>
          <th>{{ "COMMON.TARIFF.NAME" | translate }}</th>
          <th>{{ "COMMON.TARIFF.CLASS" | translate }}</th>
          <th>{{ "COMMON.TARIFF.RATE" | translate }}</th>
          <th>{{ "COMMON.TARIFF.SERVICE_TYPES" | translate }}</th>
          <th>{{ "COMMON.TARIFF.CUSTOMER_TYPES" | translate }}</th>
          <th>{{ "COMMON.TARIFF.USE_OF_PREMISES" | translate }}</th>
          <th>{{ "COMMON.TARIFF.SLT_STATUS" | translate }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let tariff of tariffs" data-bs-toggle="modal" data-bs-target="#editAddModal" (click)="selectTariff(tariff)">
          <td>
            {{ tariff.name | hasValue }}
          </td>
          <td>
            {{ tariff.class | hasValue }}
          </td>
          <td>
            {{ tariff.rate | hasValue }}
          </td>
          <td>
            {{ tariff.currentServiceTypes | hasValue }}
          </td>
          <td>
            {{ tariff.currentCustomerTypes | hasValue }}
          </td>
          <td>
            {{ tariff.currentUseOfPremises | hasValue }}
          </td>
          <td>
            {{ findSltById(tariff.sltStatusId)?.value | hasValue }}
          </td>
          <td>
            <svg
              width="15"
              data-bs-toggle="modal"
              data-bs-target="#deleteTariff"
              height="15"
              (click)="$event.stopPropagation(); onDeleteTariff(tariff)"
              viewBox="0 0 22 22"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22ZM11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM6 11C6 10.4477 6.44772 10 7 10H15C15.5523 10 16 10.4477 16 11C16 11.5523 15.5523 12 15 12H7C6.44772 12 6 11.5523 6 11Z"
                fill="#17171A"
              />
            </svg>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="pagination">
      <app-asset-list-pagination
        [pageFromList]="currentPage"
        (pageChanged)="onPageChange($event)"
        [totalItems]="count"
      >
      </app-asset-list-pagination>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="editAddModal"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content edit-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header edit-modal-header">
        <h5 class="modal-title" id="tariffModalTitle">
          {{ (isEditMode ? "COMMON.EDIT" : "COMMON.NEW") | translate }}
          {{ "COMMON.TARIFF.SINGLE" | translate }}
        </h5>
      </div>
      <div class="modal-body edit-modal-body">
        <div>
          <span>{{ "COMMON.TARIFF.NAME" | translate }}</span>
          <label for="nameInput">
            <input
              id="nameInput"
              type="text"
              [(ngModel)]="updatedTariff.name"
              [placeholder]="('COMMON.TARIFF.SINGLE' | translate) + ' ' + ('COMMON.TARIFF.NAME' | translate)"
            />
          </label>
        </div>
        <div class="edit-field">
          <span>{{ "COMMON.TARIFF.CLASS" | translate }}</span>
          <label for="classInput">
            <input
              id="classInput"
              type="text"
              [(ngModel)]="updatedTariff.class"
              [placeholder]="('COMMON.TARIFF.SINGLE' | translate) + ' ' + ('COMMON.TARIFF.CLASS' | translate)"
            />
          </label>
        </div>
        <div class="edit-field">
          <span>{{ "COMMON.TARIFF.RATE" | translate }}</span>
          <label for="rateInput">
            <input
              id="rateInput"
              type="number"
              [(ngModel)]="updatedTariff.rate"
              [placeholder]="('COMMON.TARIFF.SINGLE' | translate) + ' ' + ('COMMON.TARIFF.RATE' | translate)"
            />
          </label>
        </div>
        <div class="edit-field">
          <span>{{ "COMMON.TARIFF.SLT_STATUS" | translate }}</span>
          <label for="sltSelect">
            <select id="sltSelect" [(ngModel)]="selectedSltKey">
              <option [ngValue]="null" disabled>{{ "COMMON.TARIFF.SLT_STATUS" | translate }}</option>
              <option *ngFor="let slt of sltOptions" [ngValue]="slt.key">
                {{ slt.value }}
              </option>
            </select>
          </label>
        </div>
        <app-multi-select-dropdown style="margin-top: 1.8rem;"
          [items]="serviceTypeItems"
          [label]="'COMMON.TARIFF.SERVICE_TYPES' | translate"
          (shareCheckedList)="onServiceTypesSelected($event)"
        >
        </app-multi-select-dropdown>
        <app-multi-select-dropdown
          [items]="customerTypeItems"
          [label]="'COMMON.TARIFF.CUSTOMER_TYPES' | translate"
          (shareCheckedList)="onCustomerTypesSelected($event)"
        >
        </app-multi-select-dropdown>
        <app-multi-select-dropdown
          [items]="useOfPremisesItems"
          [label]="'COMMON.TARIFF.USE_OF_PREMISES' | translate"
          (shareCheckedList)="onUseOfPremisesSelected($event)"
        >
        </app-multi-select-dropdown>
      </div>
      <div class="modal-footer edit-modal-footer">
        <div>
          <button class="cancel" data-bs-dismiss="modal" #closeEditModal>{{ "COMMON.CANCEL" | translate }}</button>
        </div>
        <div>
          <button class="save" (click)="save()">{{ "COMMON.SAVE" | translate }}</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="deleteTariff"
  tabindex="-1"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content delete-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header delete-modal-header">
        <h5 class="modal-title" id="deleteTariffTitle">
          {{ "CRUD_SETTINGS.ARE_YOU_SURE_DELETE" | translate }} {{ "COMMON.TARIFF.SINGLE" | translate }}?
        </h5>
      </div>
      <div class="modal-footer delete-modal-footer">
        <button type="button" class="btn btn-primary" (click)="deleteTariff()" data-bs-dismiss="modal">
          {{ "COMMON.DELETE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>


<ng-template #filterTemplate>
  <div class="crud-filter">
    <div class="filters-wrapper">
      <div class="search-bar">
        <img
          src="assets/icons/search.svg"
          alt="Search icon"
          class="search-icon"
        />
        <input
          type="text"
          class="search-input"
          [placeholder]="'COMMON.SEARCH' | translate"
          [(ngModel)]="searchText"
          (keyup.enter)="onSearch()"
          (input)="onSearchChange()"
        />
      </div>
    </div>
  </div>
</ng-template>
